import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-monuments-second',
  templateUrl: './monuments-second.component.html',
  styleUrls: ['./monuments-second.component.css']
})
export class MonumentsSecondComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  navigateToMonument_01() {
    this.router.navigateByUrl("/description/monument-01")
    console.log("this was called ")
  }

  navigateToMonument_02() {
    this.router.navigateByUrl("/description/monument-02")
    console.log("this was called ")
  }

  navigateToMonument_03() {
    this.router.navigateByUrl("/description/monument-03")
    console.log("this was called ")
  }

  navigateToMonument_04() {
    this.router.navigateByUrl("/description/monument-04")
    console.log("this was called ")
  }

  navigateToMonument_05() {
    this.router.navigateByUrl("/description/monument-05")
    console.log("this was called ")
  }

  navigateToMonument_06() {
    this.router.navigateByUrl("/description/monument-06")
    console.log("this was called ")
  }

}
